"use client";

import { ExternalLink } from "lucide-react";
import { useT } from "@/lib/locale";

interface NewsItem {
  date: string;
  headline: string;
  url: string;
}

const LATEST: NewsItem[] = [
  {
    date: "Mar 21, 2026",
    headline:
      "Students Power Innovation at the 14th Annual Pelican Energy TCI National Science and Technology Fair",
    url: "https://www.pelicanenergytci.com/students-power-innovation-at-the-14th-annual-pelican-energy-tci-national-science-and-technology-fair/",
  },
  {
    date: "Jan 21, 2026",
    headline:
      "Pelican Energy TCI and TCI Government Announce Withdrawal of Proposed Rate Increase",
    url: "https://www.pelicanenergytci.com/pelican-energy-tci-and-tci-government-announce-withdrawal-of-proposed-rate-increase/",
  },
  {
    date: "Dec 5, 2025",
    headline:
      "Pelican Energy TCI Recognised with EEI Emergency Recovery Award",
    url: "https://www.pelicanenergytci.com/news/",
  },
];

export default function LatestStrip() {
  const t = useT();
  return (
    <aside aria-label={t("latest.ariaLabel")} className="bg-neutral-50 border-t border-neutral-200">
      <div className="max-w-6xl 2xl:max-w-[1408px] mx-auto px-4 sm:px-6 py-4">
        <div className="flex flex-col sm:flex-row sm:items-baseline sm:gap-4">
          <span className="text-xs font-semibold text-neutral-700 uppercase tracking-wider flex-shrink-0">
            {t("latest.heading")}
          </span>
          <ul className="flex flex-col gap-1 mt-2 sm:mt-0 flex-1">
            {LATEST.map((item) => (
              <li key={item.url} className="flex items-baseline gap-2 text-sm">
                <span className="text-neutral-600 font-mono text-xs flex-shrink-0 w-20">
                  {item.date}
                </span>
                <a
                  href={item.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-neutral-700 hover:text-brand-primary transition-colors"
                >
                  {item.headline}
                </a>
              </li>
            ))}
          </ul>
          <a
            href="https://www.pelicanenergytci.com/news/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-brand-primary-dark hover:underline mt-2 sm:mt-0 flex-shrink-0 inline-flex items-center gap-1 py-1 -my-1"
          >
            {t("latest.more")} <ExternalLink size={12} aria-hidden />
          </a>
        </div>
      </div>
    </aside>
  );
}
